import React, { useEffect, useState } from "react";
import "./AddInterview.css";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router";
import { getallcategory, addsubcategorylist } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "SubCategory name is required";
  }
  if (!values.type) {
    errors.type = "Required";
  }
  return errors;
};

const Addsubcategory = () => {
  const [load, setload] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [cat, setcat] = useState([]);
  const [preview, setPreview] = useState();
  const [image, setImage] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    getcategory();
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      type: "",
    },
    validate,
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const getcategory = async () => {
    try {
      const responce = await getallcategory();
      setcat(responce.data.data);
      formik.setFieldValue("type", responce.data.data[0].id);
    } catch (error) {
      console.log(error);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await addsubcategorylist(values.type, values.name);
      navigate("/SubCategories_List");
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  console.log(cat);
  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Add Subcategory</h1>
        </div>
        <div className="category-card">
          <form onSubmit={formik.handleSubmit} className="category-form">
            <div className="category-field-group">
              <label className="category-field-label">
                <span>Subcategory Name</span>
                <span className="required-star">*</span>
              </label>
              <br />
              <input
                onChange={formik.handleChange}
                name="name"
                type="text"
                placeholder="Subcategory Name"
                minLength={1}
                maxLength={200}
                //   value={data.name}
                className={`category-input ${formik.errors.name && "category-input-error"}`}
              />
              {formik.errors.name ? (
                <p className="category-error">{formik.errors.name} </p>
              ) : null}
            </div>
            <div className="category-field-group">
              <label className="category-field-label">
                <span>Category Type</span>
                <span className="required-star">*</span>
              </label>
              <br />
              <select
                onChange={formik.handleChange}
                name="type"
                className={`category-input ${formik.errors.type && "category-input-error"}`}
                value={formik.values.type}
              >
                {cat.map((i) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>
              {formik.errors.type ? (
                <p className="category-error">{formik.errors.type} </p>
              ) : null}
            </div>

            {/* <div>
            <label htmlFor="img">
              <p className="Auth_label">Category Image</p>

              {preview ? (
                <img src={preview} alt="editprofile_image" className="images_cate" />
              ) : (
                <>
                  <div className="addbox_image">
                    <img src={addimg} alt="add image" />
                  </div>
                </>
              )}
            </label>
            <input
              onChange={handleupload}
              id="img"
              name="img"
              type="file"
              className="Auth_input"
              style={{ display: 'none' }}
            />
            {formik.errors.name ? <p className="invalid">{formik.errors.name} </p> : null}
          </div> */}
            <div />
            <button className="category-submit-btn" type="Submit">
              {load ? "Adding..." : "Save"}
            </button>
          </form>
        </div>
      </div>
      {load && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Addsubcategory;
